import * as Mui from "@mui/material";
import { RadioProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";

const FormRadio = (props: RadioProps) => {
  const { formProps, baseProps } = destructProps(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";
  return (
    <Mui.FormControl
      error={error}
      fullWidth={baseProps.fullWidth}
    >
      <Mui.FormLabel>{baseProps.label}</Mui.FormLabel>

      <Mui.RadioGroup
        onChange={(_event, value) => form?.onChange && form.onChange(value)}
        name={formProps.name}
        value={form?.value}
        defaultValue={baseProps.defaultValue}
        row={baseProps.row}
      >
        {baseProps.options.map((option) => {
          return (
            <Mui.FormControlLabel
              control={(
                <Mui.Radio
                  {...baseProps}
                  value={option.value}
                />
              )}
              label={option.label}
            />
          );
        })}
      </Mui.RadioGroup>

      <Mui.FormHelperText>{helperText}</Mui.FormHelperText>
    </Mui.FormControl>
  )
}

export default FormRadio;